// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid-list .icon[data-v-f9882a92] {\n  width: 0.64rem;\n  display: block;\n  margin-bottom: 0.08rem;\n}\n.grid-list .name[data-v-f9882a92] {\n  font-size: 0.32rem;\n}\n", ""]);
// Exports
module.exports = exports;
